const s = (i) => i ? i.offsetWidth < i.scrollWidth : !1;
export {
  s as isEllipsisActive
};
//# sourceMappingURL=index.js.map
